import moment from 'moment'

export function data() {
  return {
    formData: {
      actionItemNoteID: 0,
      author: '',
      note: '',
      description: ''
    },
    isDebug: true,
    isOpen: false,
    loading: true,
    isFetching: false,
    openOnFocus: true,
    formComplete: false,
    actionItemID: 0,
    actionItem: {},
    actionItemTitle: '',
    actionItemStatusList: [],
    actionItemPriorityList: [],
    sourceBoardPackagesList: [],
    formatDateFn: function(value) {
      return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
    },
    selectedRow: null,
    buttonText: 'Add'
  }
}
